module.exports = __webpack_public_path__ + "static/media/mastercard.4d35b129.svg";